export enum PaymentMethods {
  PIX = 0,
  CARTAO = 4,
  GRATUITO = 6,
}

export const paymentMethods: { [key: number]: string } = {
  [PaymentMethods.PIX]: 'Pix',
  [PaymentMethods.CARTAO]: 'Cartão',
};

export default function parsePaymentMethodName(paymentMethod: number | string) {
  const paymentMethodName = paymentMethods[Number(paymentMethod)];
  return !paymentMethodName ? '' : paymentMethodName;
}
